import apiClient from './client'

import type { CallLog, CallLogInput, PaginatedResponse } from '@/types/gia'

interface CallLogFilters {
  page?: number
  centro?: number
  atendido?: number
  valoracion?: string
}

const callLogsApi = {
  list: async (filters: CallLogFilters = {}): Promise<PaginatedResponse<CallLog>> => {
    const response = await apiClient.get<PaginatedResponse<CallLog>>('/call-logs/', {
      params: filters
    })

    return response.data
  },

  create: async (payload: CallLogInput): Promise<CallLog> => {
    const response = await apiClient.post<CallLog>('/call-logs/', payload)

    return response.data
  },

  update: async (id: number, payload: Partial<CallLogInput>): Promise<CallLog> => {
    const response = await apiClient.put<CallLog>(`/call-logs/${id}/`, payload)

    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/call-logs/${id}/`)
  }
}

export default callLogsApi
